/** biome-ignore-all lint/suspicious/noExplicitAny: allow any */
import {selectIsPremiumTemplate} from '~/common/FabricInvitation/reducers/fabricTemplate/selectors';
import {selectIsPremiumSafe} from '~/common/fabric/EventGuests/reducers/eventDetails/selectors';
import {selectGuestCount} from '~/common/fabric/EventGuests/reducers/guests/selectors';
import {isFabricWebview} from '~/common/utils/webview';

export const eventStepsType = {
  PREMIUM: 'premium',
  PREMIUM_ADD_GUESTS_AFTER: 'premium_add_guests_after',
  FREEMIUM: 'freemium',
  FREEMIUM_WITH_GUESTS: 'freemium_with_guests',
  FREE: 'free',
  FREE_WITH_GUESTS: 'free_with_guests',
  // AB TEST: 'test_add-guests-step-free' - TO ROLL BACK: Remove this type and references to it
  FREE_WITH_GUESTS_AB: 'free_with_guests_ab',
};

type State = {
  eventDetails: Record<string, any>;
  fabricTemplate: Record<string, any>;
  details: Record<string, any>;
  user: Record<string, any>;
  [key: string]: Record<string, any>;
};

export const addGuestsPreCondition = (state: State, preConditions: boolean[] = []) => {
  const isPremium: boolean = selectIsPremiumTemplate(state);
  const hasGuests = selectGuestCount(state) > 0;

  return [...preConditions, !isPremium, !hasGuests, !isFabricWebview()].every(Boolean);
};

// AB TEST: 'test_add-guests-step-free'
// TO ROLL BACK: Remove this function and clean up all references to isInFreeAddGuestsStepExpVariant.
// The experiment changes the flow for free users by adding a guests step.
// References to clean up can be found in:
// - CreateFabricInvitation/routes/Upsell/Upsell.js
// - CreateFabricInvitation/components/NavHeader/NavHeader.js
// - CreateFabricInvitation/navigation/createSteps.js
// - common/fabric/routes/EventReview/EventReview.js
export const isInFreeAddGuestsStepExpVariant = (state: State) => {
  const isWebview = isFabricWebview();
  if (isWebview) return false; // Exclude WebView/apps

  if (state.fabricTemplate?.premium) return false; // Exclude Premium templates

  const variation = evite.experiments.getOrSetVariation('test_add-guests-step-free', 'control');
  return variation === 'variant';
};

export const getEventStepsType = (state: State) => {
  const hasGuests = selectGuestCount(state) > 0;
  const {pathname} = window.location;
  const addGuestsPreConditionsMet = addGuestsPreCondition(state);
  // AB TEST: 'test_add-guests-step-free' - TO ROLL BACK: Remove this line and the related conditional below
  const inFreeAddGuestsStepExpVariant = isInFreeAddGuestsStepExpVariant(state);
  if (state.fabricTemplate?.premium && addGuestsPreConditionsMet) {
    return eventStepsType.PREMIUM_ADD_GUESTS_AFTER;
  }
  const isPremium: boolean = selectIsPremiumSafe(state);
  // AB TEST: 'test_add-guests-step-free' - TO ROLL BACK: Remove this entire conditional block
  if (inFreeAddGuestsStepExpVariant) {
    return isPremium ? eventStepsType.FREEMIUM_WITH_GUESTS : eventStepsType.FREE_WITH_GUESTS_AB;
  }
  if (hasGuests || pathname.includes('guests')) {
    return isPremium ? eventStepsType.FREEMIUM_WITH_GUESTS : eventStepsType.FREE_WITH_GUESTS;
  }
  if (!addGuestsPreConditionsMet) {
    return eventStepsType.PREMIUM;
  }
  return isPremium ? eventStepsType.FREEMIUM : eventStepsType.FREE;
};
